// PopupNotificationHandler.js
import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import PopupNotificationHandler from '../component/PopupNotificationHandler.jsx';
import getIsValidPopupNotification from '../selector/getIsValidPopupNotification.js';
import getPopupNotificationData from '../selector/getPopupNotificationData.js';
import getOperationData from '../selector/getOperationData.js';
import trackEvent from '../action/trackEvent.js';
import closePopupNotifications from '../action/closePopupNotifications.js';
import fetchNotificationOembedData from '../action/fetchNotificationOembedData.js';
import sendMeNotificationsRead from '../action/sendMeNotificationsRead.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

const mapStateToProps = (state, { notificationTag }) => {
  const position = getOperationData(
    state,
    ['popupNotification', 'detail', notificationTag],
    'position'
  );
  const width = getOperationData(
    state,
    ['popupNotification', 'size', position],
    'width'
  );
  const height = getOperationData(
    state,
    ['popupNotification', 'size', position],
    'height'
  );
  return {
    width,
    height,
    isValid: getIsValidPopupNotification(state, notificationTag),
    notificationData: getPopupNotificationData(state, notificationTag),
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: path => dispatch(push(path)),
    closePopupNotifications: data => dispatch(closePopupNotifications(data)),
    fetchNotificationOembedData: data =>
      dispatch(fetchNotificationOembedData(data)),
    trackEvent: data => dispatch(trackEvent(data)),
    sendMeNotificationsRead: data => dispatch(sendMeNotificationsRead(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopupNotificationHandler);
